<template>
  <transition appear name="fade">
    <div class="t3m-ImageMap-hotspots" v-if="status==='idle'">
      <div>
        <t3m-hotspot v-for="h in hotspots" :key="h.id" :specs="h" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import t3mHotspot from "@/components/t3mHotspot/";
export default {
  name: "t3mHotspots",
  components: {
    t3mHotspot
  },
  computed: {
    ...mapState(["hotspots", "status"])
  },
  methods: {}
};
</script>
